import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "options", "showSearchbox", "use"];
/* eslint-disable hubspot-dev/no-private-classes */
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import classNames from 'classnames';
import memoizeOne from 'react-utils/memoizeOne';
import UISelect from 'UIComponents/input/UISelect';
import UISearchInput from 'UIComponents/input/UISearchInput';
import UIDropdownDivider from 'UIComponents/dropdown/UIDropdownDivider';
import { uniqueId } from 'UIComponents/utils/underscore';
import { OptionOrGroupType, isOptionGroup } from 'UIComponents/types/OptionTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const ToolbarSelectSearchInput = props => /*#__PURE__*/_jsx(UISearchInput, Object.assign({}, props, {
  clearable: false,
  icon: false,
  inputClassName: "private-form__control--small"
}));
const hasGroups = options => options[0] && isOptionGroup(options[0]);
const flattenOptions = options => {
  if (!hasGroups(options)) return options;
  const flatOptions = [];
  options.forEach((optionGroup, i) => {
    optionGroup.options.forEach(option => flatOptions.push(option));
    if (i < options.length - 1) {
      flatOptions.push({
        disabled: true,
        isSpecial: true,
        text: '',
        value: '',
        rawNode: /*#__PURE__*/_jsx(UIDropdownDivider, {
          className: "m-all-0"
        })
      });
    }
  });
  return flatOptions;
};
class UITextToolbarSelect extends PureComponent {
  constructor(props) {
    super(props);
    this.computeButtonStyle = () => {
      // Set the button width based on the widest option text.
      const {
        options,
        placeholder
      } = this.props;
      const {
        buttonStyle
      } = this.state;
      const buttonEl = document.getElementById(this._id);
      if (!buttonEl) return;
      const originalButtonElWidthStyle = buttonEl.style.width;
      buttonEl.style.width = '';
      const textEl = buttonEl.querySelector('[data-option-text]');
      if (!textEl) {
        return;
      }
      const originalTextElContents = textEl.innerHTML;
      let maxButtonWidth = 0;
      if (placeholder) {
        textEl.textContent = placeholder;
        maxButtonWidth = buttonEl.offsetWidth;
      }
      const flatOptions = this._flattenOptions(options);
      flatOptions.forEach(option => {
        textEl.textContent = option.text;
        const measuredOptionWidth = buttonEl.offsetWidth;
        maxButtonWidth = Math.max(maxButtonWidth, measuredOptionWidth);
      });
      maxButtonWidth = Math.ceil(maxButtonWidth + 1);
      if (maxButtonWidth === 0) {
        this.setState({
          buttonStyle: null
        });
      } else if (!buttonStyle || buttonStyle.width !== maxButtonWidth) {
        this.setState({
          buttonStyle: {
            width: maxButtonWidth
          }
        });
      }
      buttonEl.style.width = originalButtonElWidthStyle;
      textEl.innerHTML = originalTextElContents;
    };
    this.state = {
      buttonStyle: null
    };
    this._id = uniqueId('text-toolbar-select-');
    this._flattenOptions = memoizeOne(flattenOptions);
  }
  componentDidMount() {
    this.computeButtonStyle();
  }
  componentDidUpdate(prevProps) {
    // ⚠️ This condition prevents infinite loops! ⚠️
    if (prevProps.options !== this.props.options) {
      this.computeButtonStyle();
    }
  }
  render() {
    const _this$props = this.props,
      {
        className,
        options,
        showSearchbox,
        use
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      buttonStyle
    } = this.state;
    const flatOptions = this._flattenOptions(options);
    return /*#__PURE__*/_jsx(UISelect, Object.assign({
      buttonSize: "sm"
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      ,
      buttonStyle: buttonStyle,
      buttonUse: use === 'on-dark' ? 'tertiary-extra-light' : 'tertiary-light',
      className: classNames('private-button--toolbar', className),
      id: this._id,
      minimumSearchCount: showSearchbox ? 0 : Infinity,
      options: flatOptions,
      resultsClassName: "private-typeahead-results--toolbar",
      searchClassName: "private-search-control__wrapper--toolbar",
      SearchInput: ToolbarSelectSearchInput
    }, rest));
  }
}
UITextToolbarSelect.propTypes = {
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.arrayOf(OptionOrGroupType).isRequired,
  placeholder: PropTypes.string,
  showSearchbox: PropTypes.bool.isRequired,
  use: PropTypes.oneOf(['', 'on-dark']).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string
};
UITextToolbarSelect.defaultProps = {
  showSearchbox: false,
  use: ''
};
UITextToolbarSelect.displayName = 'UITextToolbarSelect';
export default UITextToolbarSelect;